import { LocationAddOnSettings } from "./index";

export const transformSettingsToState = (
    locationSettings: Record<string, { value: any }>,
): LocationAddOnSettings => {
    return {
        isEnabled: locationSettings["fullTimeScheduling.enabled"]?.value ?? false,
        allowWorkerPreferences: locationSettings["fullTimeScheduling.workerSetPref.enabled"]?.value ?? false,
        autoOptimize: locationSettings["fullTimeScheduling.scheduleGeneration.enabled"]?.value ?? false,
    };
};

export const transformStateToSettingsPayload = (
    state: LocationAddOnSettings,
    locationId: number,
): any[] => {
    return [
        {
            code: "fullTimeScheduling.enabled",
            entity: "location",
            entityId: locationId,
            type: "System.Boolean",
            value: state.isEnabled,
        },
        {
            code: "fullTimeScheduling.workerSetPref.enabled",
            entity: "location",
            entityId: locationId,
            type: "System.Boolean",
            value: state.allowWorkerPreferences,
        },
        {
            code: "fullTimeScheduling.scheduleGeneration.enabled",
            entity: "location",
            entityId: locationId,
            type: "System.Boolean",
            value: state.autoOptimize,
        },
    ];
};